import { module } from 'modujs'

export default class extends module {
  constructor(m) {
    super(m)

    this.isCustomLoad = this.el.hasAttribute('data-video-custom-load')
    this.isLoaded = false
    this.onCanPlayThrough = this.onCanPlayThrough.bind(this)
  }

  togglePlay(e) {
    if (e.way === 'enter') {
      if (this.isLoaded) {
        this.play()
      }
      else {
        if (this.isCustomLoad === false) {
          this.loadAndPlay()
        }
      }
    }
    else {
      this.pause()
    }
  }

  play() {
    this.el.play()
    this.isLoaded = true
    this.loaded()
  }

  pause() {
    this.el.pause()
  }

  loaded() {
    this.el.parentNode.classList.add('-loaded')
  }

  loadAndPlay() {
    const source = this.el.querySelector('source[data-src]')

    if (source) {
      source.setAttribute('src', source.getAttribute('data-src'))
      source.removeAttribute('data-src')
      this.el.load()
      this.el.addEventListener('canplaythrough', this.onCanPlayThrough)
    }
  }

  onCanPlayThrough() {
    this.play()
    this.isLoaded = true
    this.loaded()
  }

  destroy() {
    this.el.removeEventListener('canplaythrough', this.onCanPlayThrough)
  }
}
